export default __webpack_public_path__ + "static/media/Twinkle-Sound.a5ca9dc8.mp3";